import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	changeTemplateModalTitle: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.change-template-modal-title',
		defaultMessage: 'Change template?',
		description:
			'Title on the modal that is displayed if an existing intent template is being changed',
	},
	changeTemplateModalConfirmButtonText: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.change-template-modal-confirm-button-text',
		defaultMessage: 'Change template',
		description:
			'The text on the confirmation button which will update the intent template if clicked',
	},
});
